<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <form [formGroup]="programForm">
      <h1 class="mb-2 d-flex justify-content-between align-items-center">
        {{ createNewProgram }}
      </h1>
      <div class="row">
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="name"
              >Program name<span class="madatory-field">*</span></label
            >
            <input
              pInputText
              jniAutoCompleteBlocker
              name="name"
              type="text"
              class="form-control"
              id="name"
              formControlName="name"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['name']">
              {{ formErrors["name"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="clientOwnInv"
              value="clientOwnInv"
              [binary]="true"
              formControlName="clientOwnInv" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="clientOwnInv"
              id="clientOwnInv"
              name="clientOwnInv"
              formControlName="clientOwnInv" /> -->
            <label class="form-check-label" for="clientOwnInv">
              Client Owned Inventory
            </label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="nadelOwnInv"
              value="nadelOwnInv"
              [binary]="true"
              formControlName="nadelOwnInv" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="nadelOwnInv"
              id="nadelOwnInv"
              name="nadelOwnInv"
              formControlName="nadelOwnInv" /> -->
            <label class="form-check-label" for="nadelOwnInv">
              Nadel Owned Inventory
            </label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="uses3PL"
              formControlName="uses3PL"
              value="uses3PL"
              [binary]="true" />

            <!-- <input
              pInputText
              class="form-check-input m-0 no-bg"
              type="checkbox"
              value="uses3PL"
              id="uses3PL"
              name="uses3PL"
              formControlName="uses3PL" /> -->
            <label class="form-check-label" for="uses3PL">
              Third Party Logistics (Warehouse)
            </label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="form-group has-float-label">
            <label class="form-label" for="threePL1Id">3-PL</label>
            <p-select
              id="threePL1Id"
              formControlName="threePL1Id"
              [options]="threePLList"
              optionLabel="name"
              optionValue="value"
              placeholder="Select a 3 PL">
            </p-select>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="usesWebsite"
              formControlName="usesWebsite"
              value="usesWebsite"
              [binary]="true" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="usesWebsite"
              id="usesWebsite"
              name="usesWebsite"
              formControlName="usesWebsite" /> -->
            <label class="form-check-label" for="usesWebsite">Website</label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="form-group has-float-label">
            <label class="form-label" for="webPlatId">Platform</label>
            <p-select
              id="webPlatId"
              formControlName="webPlatId"
              [options]="platformList"
              optionLabel="name"
              optionValue="value"
              placeholder="Select Platform">
            </p-select>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="micro"
              formControlName="micro"
              value="micro"
              [binary]="true" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="micro"
              id="micro"
              name="micro"
              formControlName="micro" /> -->
            <label class="form-check-label" for="micro"> MicroSite </label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="INTL"
              formControlName="intl"
              value="intl"
              [binary]="true" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="intl"
              id="intl"
              name="INTL"
              formControlName="intl" /> -->
            <label class="form-check-label" for="intl"> INTL Program </label>
          </div>
        </div>

        <div class="col-12 mb-2">
          <div class="d-flex gap-2 d-flex align-items-center">
            <p-checkBox
              name="InStore"
              formControlName="inStoreCC"
              value="inStoreCC"
              [binary]="true" />

            <!-- <input
              pInputText
              class="form-check-input me-2 m-0 no-bg"
              type="checkbox"
              value="inStoreCC"
              id="inStoreCC"
              name="InStore"
              formControlName="inStoreCC" /> -->
            <label class="form-check-label" for="inStoreCC">
              In-Store Payment (Credit Card)
            </label>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="form-group has-float-label">
            <label class="form-label" for="inStoreCCProvider"
              >Facilitator</label
            >
            <p-select
              id="inStoreCCProvider"
              formControlName="inStoreCCProvider"
              [options]="facilitatorList"
              optionLabel="name"
              optionValue="value"
              placeholder="Select Facililator">
            </p-select>
          </div>
        </div>
        <div
          class="col prospects-panel d-flex justify-content-between mb-2 me-1 ms-2">
          <label class="p-0 d-flex align-items-center">
            <strong>Onboarded with E-Commerce Dept</strong>
          </label>
          <label class="me-1 p-0 d-flex align-items-center">
            <p-radiobutton
              id="OpenYes"
              value="true"
              class="me-2"
              name="ecomOnboard"
              formControlName="ecomOnboard"
              (onClick)="onRadioButtonClick(true)" />

            <!-- <input
              pInputText
              id="OpenYes"
              type="radio"
              class="me-2"
              name="radioEcom"
              (click)="onYesRadioButtonClick()" /> -->
            <span>Yes</span>
          </label>
          <label class="p-0 d-flex align-items-center me-5">
            <p-radiobutton
              id="onboardedNo"
              class="me-2"
              value="false"
              name="ecomOnboard"
              formControlName="ecomOnboard"
              (onClick)="onRadioButtonClick(false)" />

            <!-- <input
              pInputText
              id="OpenNo"
              type="radio"
              class="me-2"
              name="radioEcom"
              (click)="onNoRadioButtonClick()" /> -->
            <span>No</span>
          </label>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="website1">Website 1 URL</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="website1"
              type="text"
              class="form-control"
              id="website1"
              formControlName="website1" />

            <span class="error-msg"> </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label" for="website2">Website 2 URL</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="website2"
              type="text"
              class="form-control"
              id="website2"
              formControlName="website2" />

            <span class="error-msg"> </span>
          </div>
        </div>
        <div class="col mb-2">
          <div class="form-group has-float-label">
            <label class="form-label" for="description">Description</label>
            <textarea
              jniAutoCompleteBlocker
              pInputText
              formControlName="description"
              class="form-control"
              id="description"
              style="height: 100px"></textarea>
          </div>
        </div>

        <div class="col-12 mb-2" *ngIf="false">
          <div class="has-float-label">
            <input
              pInputText
              jniAutoCompleteBlocker
              name="brandingConsultantD365"
              type="text"
              class="form-control"
              id="brandingConsultantD365"
              formControlName="brandingConsultantD365" />
            <label class="form-label" for="brandingConsultantD365"
              >BC<span class="madatory-field">*</span></label
            >
          </div>
        </div>
      </div>
      <!-- <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!programForm.valid"
        (click)="onSubmit()">
        Save
      </button> -->

      <p-button
        label="Save"
        [disabled]="!programForm.valid"
        (click)="onSubmit()" />
    </form>
  </div>
</p-drawer>
